<tran-application-detail-dashboard-box [heading]="heading()">
    @if (isLoading()) {
        <div class="py-4 flex flex-col gap-4" aria-hidden="true">
            <span class="si-skeleton placeholder-lg w-[45%]"></span>
            <span class="si-skeleton placeholder-lg w-full"></span>
            <span class="si-skeleton placeholder-lg w-[75%]"></span>
            <span class="si-skeleton placeholder-lg w-full"></span>
            <span class="si-skeleton placeholder-lg w-[70%]"></span>
        </div>
    } @else {
        <form [formGroup]="activeForm()">
            @if (!readonly()) {
                <div class="py-4">
                    <si-form-item
                        [label]="'components.application-detail-dashboard.application-information.name' | translate"
                        [formErrorMapper]="{ required: 'application-form.required' | translate }"
                    >
                        <input
                            type="text"
                            class="form-control"
                            formControlName="name"
                            [placeholder]="
                                'components.application-detail-dashboard.application-information.name-placeholder'
                                    | translate
                            "
                        />
                    </si-form-item>
                </div>
            }
            <div class="py-4">
                <tran-application-detail-people
                    label="components.application-detail-dashboard.application-information.applicants"
                    [people]="requesters()"
                    [control]="activeForm().controls.applicants"
                    [readonly]="readonly()"
                    [multi]="true"
                />
            </div>

            <div class="py-4">
                <si-form-item
                    [label]="
                        'components.application-detail-dashboard.application-information.affected-locations' | translate
                    "
                >
                    @if (!readonly()) {
                        <tran-location-selector
                            [control]="activeForm().controls.affectedLocations"
                            [locations]="allLocations()"
                        />
                    } @else {
                        <si-pills-input
                            [placeholder]="
                                'components.application-detail-dashboard.application-information.affected-locations'
                                    | translate
                            "
                            [formControl]="affectedLocationsDisplayControl"
                            [readonly]="true"
                        />
                    }
                </si-form-item>
            </div>
            <div class="py-4">
                <tran-org-unit-selector
                    label="components.application-detail-dashboard.application-information.involved-organizations"
                    [control]="activeForm().controls.involvedOrganizations"
                    [displayControl]="involvedOrganizationsDisplayControl"
                    [orgUnits]="allOrgUnits()"
                    [readonly]="readonly()"
                />
            </div>
        </form>
    }
</tran-application-detail-dashboard-box>
